import { Injectable, Inject } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';
import { UserInfoService } from './user-info.service';
import { NzMessageService } from 'ng-zorro-antd/message';
class SearchAPIMetaDataDO {
  key: any;
  keyDescription: any;
  valueInputType: any;
  lookupName: any;
  lookup: any;
  enable: any;
  isMandatory: Boolean;
}
@Injectable({
  providedIn: 'root'
})
export class MetadataService {

  constructor(
    private apiRequest: ApiRequestService,
    private translate: TranslateService,
    private userInfoService : UserInfoService,
    private message: NzMessageService
  ) { }

  productBasedConfigData;
  fetchAPIMetaData(apiName: any): Observable<any> {
    let me = this;

    let APIMetaDataDataSubject = new Subject<any>();
    
    let pathVariables = [];
    pathVariables.push(apiName);
    this.apiRequest.getCallWithAPIMapper('fetchByAPIName', null, null, pathVariables)
      .subscribe(jsonResp => {
        let returnObj = jsonResp;
        console.log(returnObj);
        APIMetaDataDataSubject.next(returnObj);
      });

    return APIMetaDataDataSubject;
  }

  getSearchCriteriaList(apiName): Observable<any> {
    if (apiName) {
      let searchCriteriaSubject = new Subject()
      let CRITERIALOOKUP = []
      this.fetchAPIMetaData(apiName)
        .subscribe(jsonResp => {
          if (jsonResp && Array.isArray(jsonResp)) {
            jsonResp.forEach(criteria => {
              let searchCriteriaDO = new SearchAPIMetaDataDO();
              searchCriteriaDO.key = criteria.attributeName;
              searchCriteriaDO.keyDescription = criteria.description;
              searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
              searchCriteriaDO.lookupName = criteria.attributeLookupCd;
              searchCriteriaDO.lookup = [];
              searchCriteriaDO.enable = true;
              searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
              CRITERIALOOKUP.push(searchCriteriaDO)
            })
            searchCriteriaSubject.next(CRITERIALOOKUP)
          }
          else {

            this.message.error(`Server Error: Unable to fetch search criteria for ${apiName}`)
          }
        })

      return searchCriteriaSubject
    }
  }

  fetchAPIMetaDataForInbox(apiName: any): Observable<any> {
    let me = this;

    let APIMetaDataDataSubject = new Subject<any>();

    let pathVariables = [];
    pathVariables.push(apiName);
    this.apiRequest.getCallWithAPIMapper('inboxApiMetaData', null, null, pathVariables)
      .subscribe(jsonResp => {
        let returnObj = jsonResp;
        console.log(returnObj);
        APIMetaDataDataSubject.next(returnObj);
      });

    return APIMetaDataDataSubject;
  }

  fetchUserCountry() {
    let userObj: any = this.userInfoService.getUserInfo();
    let me = this;

    let fetchUserCountrySubject = new Subject<any>();

    let pathVariables = [];
    pathVariables.push(userObj.baseCompanyCd)
    this.apiRequest.getCallWithAPIMapper('fetchByCompanyNum', null, null, pathVariables)
      .subscribe(jsonResp => {
        let returnObj = jsonResp;
        fetchUserCountrySubject.next(returnObj);
      });

    return fetchUserCountrySubject;
  }
}
